module.exports = "<i class=\"fa fa-chain-broken clickable text-danger\"\n   aria-hidden=\"true\"\n   title=\"Automatic calculation is off.\"\n   ng-show=\"$ctrl.ngModel\"\n   ng-click=\"$ctrl.toggle()\">\n</i>\n<i class=\"fa fa-link clickable text-primary\"\n   aria-hidden=\"true\"\n   title=\"Automatic calculation in on.\"\n   ng-show=\"!$ctrl.ngModel\"\n   ng-click=\"$ctrl.toggle()\">\n</i>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/directives/acres.calc.control.html
// module id = 632
// module chunks = 0